import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        show:true,
        map:false,
        idbottom:true,
        video:false,
        videoId:'5D201',
        building:'five',
        videoSrc:'',
        monitorNum:'',
        activeNum: -1,
        idbottom1:true,
        lvideo:[require('./../assets/video/机器人实操基地1.mp4'),require('./../assets/video/机器人实操基地12.mp4'),require('./../assets/video/机器人实操基地13.mp4'),require('./../assets/video/机器人实操基地14.mp4'),require('./../assets/video/机器人实操基地15.mp4')],
        jvideo:[require('./../assets/video/教室1.mp4'),require('./../assets/video/教室2.mp4'),require('./../assets/video/教室3.mp4')]
    },
    getters:{
        getVideo:state=>{
            return state.videoSrc
        }
    },
    mutations: {
        changevideo(state){
            if(state.building == 'n_L' | state.building == 'L'){
                let num = parseInt(Math.random()*5)
                state.videoSrc = state.lvideo[num];
            }else if(state.building == 'three' | state.building == 'five'){
                let num = parseInt(Math.random()*3)
                state.videoSrc = state.jvideo[num];
            }
            
        }
    },
    actions: {
    },
    modules: {
    }
})
